import {WhiskyBarSidebarPromotionTileType} from '../../types';
import {Link, Image} from '@shopify/hydrogen';
import {CorprateX1TastingJPEG, CorprateX1TastingWEBP} from '../../assets/img';
import Skeleton from 'react-loading-skeleton';

interface WhiskyBarSidebarPromoTileProps {
  promoTile: WhiskyBarSidebarPromotionTileType;
}

export default function WhiskyBarSidebarPromoTile({
  promoTile,
}: WhiskyBarSidebarPromoTileProps) {
  return (
    <div className="widget-tile blue-tile">
      {!promoTile ? (
        <Skeleton width={325} height={350} />
      ) : (
        <>
          <div className="widget-tile__img">
            <picture>
              <source srcSet={CorprateX1TastingWEBP} type="image/webp" />
              <source srcSet={CorprateX1TastingJPEG} type="image/jpeg" />
              <Image
                width={1400}
                height={500}
                src={CorprateX1TastingWEBP}
                alt="Corporate tating"
              />
            </picture>
          </div>
          <div className="widget-tile__content">
            <h2 className="widget-tile__title">
              <div dangerouslySetInnerHTML={{__html: promoTile.title}} />
            </h2>
            <div className="widget-tile__button">
              <Link
                to={promoTile.button_url}
                className="button button_color_white button_full button_accent_hover"
              >
                {promoTile.button_text}
              </Link>
            </div>
            <div className="align-center mt-25 seconary-font color-white font-bold">
              <Link to={promoTile.link_url}>{promoTile.link_text}</Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
